import React from 'react'

import { useField, useFormikContext } from 'formik'
import moment from 'moment'

import Label from '../components/Label'
import MonthPicker from '../components/MonthPicker'
import FieldProps from './FieldProps'
import Error from './FormItemError'

import './FormikStyles.less'

interface MonthPickerProps extends FieldProps {
  defaultValue?: moment.Moment
  disabledDate?: (current: moment.Moment | null) => boolean
  monthCellContentRender?: (date: moment.Moment, locale: any) => React.ReactNode
  format?: string | string[]
}

const FormikMonthPickerField: React.FC<MonthPickerProps | any> = (props) => {
  const [field, meta] = useField(props)
  const context = useFormikContext()
  const showError = meta.touched && meta.error

  const onDateChange = (date: moment.Moment | null, dateString: string) => {
    context.setFieldValue(props.name, date)
  }

  return (
    <>
      <div className="formik-field">
        <div className="date-wrapper">
          {props.label && (
            <Label htmlFor={props.id || props.name} className="formik-field__input-label no-select d-block">
              {props.label}
            </Label>
          )}
          <MonthPicker onChange={onDateChange} {...props} className="formik-datepicker" />
        </div>
      </div>
      {showError && <Error>{meta.error}</Error>}
    </>
  )
}
export { FormikMonthPickerField as MonthPicker }
export default FormikMonthPickerField
